// import Vue from 'vue';
// import VueMoment from 'vue-moment';
import moment from 'moment-timezone';

moment.tz.setDefault('Europe/Riga');
moment.defaultFormat = 'DD.MM.YYYY HH:mm:ss';

// Vue.use(VueMoment, { moment });
export const MomentMixin = {
  methods: {
    moment,
    momentf(date, format = moment.defaultFormat) {
      const m = moment(date);
      if (!m.isValid()) return '';
      return m.format(format);
    }
    // moment(...args) { return moment(...args); }
  }
};

export default moment;
